import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { hostedFieldsBulletinIdSelector, isHostedFieldsFailUploadModalOpenSelector } from 'store/state/app/selectors';
import { IconWrapper, TextArea, Title, Wrapper } from './styled';
import { setHostedFieldsFailUploadModalAction, upgradeUserPlanFlow } from 'store/state/app/actions';
import { useLocale } from 'locale';
import FailIcon from 'assets/svg/fail-circle.svg';
import { Button } from 'ds/components/button';
import { ModalWrapper } from './Wrapper';
import { PrivateUserMonetizationSource } from 'store/state/app';


const FailModalBase: React.FC<{
  isOpen: boolean;
  bulletinId: string;
  setOpen: (isOpen: boolean) => void;
  onRetry: (data: { source: PrivateUserMonetizationSource; userInitiated: boolean; bulletinId: string; }) => void;
}> = ({ isOpen, bulletinId, setOpen, onRetry }) => {
  const { t } = useLocale();

  const handleRetry = () => {
    onRetry({ source: PrivateUserMonetizationSource.HostedFieldsFailUploadModal, userInitiated: true, bulletinId });
    setOpen(false);
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={() => setOpen(false)}>
      <Wrapper>
        <IconWrapper>
          <FailIcon />
        </IconWrapper>
        <Title>{t('payment.fail.modal.title')}</Title>
        <TextArea>{t('payment.failUpload.modal.text')}</TextArea>
        <Button mode="primary" size="extraLarge" onClick={handleRetry}>{t('payment.fail.modal.button')}</Button>
      </Wrapper>
    </ModalWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isHostedFieldsFailUploadModalOpenSelector(state),
  bulletinId: hostedFieldsBulletinIdSelector(state),
});

const mapDispatchToProps = {
  setOpen: setHostedFieldsFailUploadModalAction,
  onRetry: upgradeUserPlanFlow,
};

export const PaymentFailUploadModal = connect(mapStateToProps, mapDispatchToProps)(FailModalBase);
